export default __webpack_public_path__ + "static/media/agnitio-logo.6e4af7e9.svg";